// pages/AdvisoryBoard.jsx
import { motion } from "framer-motion";

import { advisoryBoardMembers } from "../data/advisoryBoardData";
import AnimatedPage from "../component/LeadershipComponents/AnimatedPage";
import SectionHeader from "../component/LeadershipComponents/SectionHeader";
import AdvisoryCard from "../component/AdvisoryCard";
import HeadingWithWatermark from "../component/HeadingWithWatermark";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

const AdvisoryBoard = () => {
  return (
    <AnimatedPage>
        <Navbar/>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 bg-white">
      
         <HeadingWithWatermark className="mb-"
          title="Eminent advisors guiding WASME's vision"
          watermarkText="Advisory Boardp"
          color="#1b73a7"
          align="center"
        />

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          // initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={{
            visible: { transition: { staggerChildren: 0.1 } }
          }}
        >
          
          {advisoryBoardMembers.map((person) => (
            <motion.div
              key={person.id}
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 }
              }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              <AdvisoryCard person={person} />
            </motion.div>
          ))}
        </motion.div>
      </div>
      <Footer/>
    </AnimatedPage>
  );
};

export default AdvisoryBoard;